import React  from 'react';
import PropTypes  from 'prop-types';
import Portal from './Portal';


const MenuModal = ({ children, size, isOpen, onClose }) => {

  // const getSize = () => {
  //   if(size === 'sm'){
  //     return 'mx-2 w-modal-xl xl:w-modal-sm lg:w-modal-md';
  //   }
  //   if(size === 'md'){
  //     return 'mx-2 w-modal-xl xl:w-modal-md lg:w-modal-md';
  //   }
  //   if(size === 'lg'){
  //     return 'mx-2 w-modal-xl xl:w-modal-lg lg:w-modal-lg';
  //   }
  //   if(size === 'full'){
  //     return 'w-modal-xl mx-2';
  //   }
  // }

  return (
    <Portal>
      <div id="modal-backdrop" className={`modal-backdrop ${isOpen ? 'show' : ''}`} />
      {/* <div id="modal-container" className={`modal-container ${isOpen ? 'show' : ''}`}>
        <div className={`${getSize()} modal`}>
          <div>
            <button type="button" className="float-right" onClick={onClose}><Icon.Close /></button>
          </div>
          <div>
            {children}
          </div>
        </div>
      </div> */}
    </Portal>
  )
}

MenuModal.defaultProps = {
  isOpen: false,
  size: 'sm',
  onClose: () => {}
}

MenuModal.propTypes = {
  onClose: PropTypes.instanceOf(Function),
  isOpen: PropTypes.bool,
  size: PropTypes.string,
  children: PropTypes.node.isRequired
}

export default MenuModal